import useBreakpoint from "hooks/useBreakpoint";
import React from "react";

const ScholarshipNavbar = ({ scholarshipInfo }) => {
  const { isMobile, isTablet, isDesktop } = useBreakpoint();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
      }}
    >
      <div>
        <img
          src="/new/logo.webp"
          alt=""
          style={{
            width: "176px",
            display: scholarshipInfo?.logoUrl ? "none" : "block",
          }}
        />
        {scholarshipInfo?.logoUrl && (
          <img
            src={scholarshipInfo.logoUrl}
            alt="Right Logo"
            style={{ height: "30px" }}
          />
        )}
      </div>
      <div></div>
    </div>
  );
};

export default ScholarshipNavbar;
